import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6748f772"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "banner" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "title" }, " #캡틴쓱 #SSG.COM #팩체인저 #종이팩재활용 #테트라팩 ", -1))
const _hoisted_3 = { class: "d-block d-md-none" }
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "d-none d-md-block" }
const _hoisted_8 = ["src"]
const _hoisted_9 = ["src"]
const _hoisted_10 = ["src"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "subtitle" }, " 캡틴쓱 시즌2 : Pack Changer ", -1))

import LogoImage from '../images/banner/logo.png';
import BannerLeftImage from '../images/banner/banner-left.png';
import BannerRightImage from '../images/banner/banner-right.png';
import LogoImageLg from '../images/banner/logo-lg.png';
import BannerLeftImageLg from '../images/banner/banner-left-lg.png';
import BannerRightImageLg from '../images/banner/banner-right-lg.png';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("img", {
        class: "logo",
        src: _unref(LogoImage),
        loading: "lazy"
      }, null, 8, _hoisted_4),
      _createElementVNode("img", {
        class: "img-left",
        src: _unref(BannerLeftImage),
        loading: "lazy"
      }, null, 8, _hoisted_5),
      _createElementVNode("img", {
        class: "img-right",
        src: _unref(BannerRightImage),
        loading: "lazy"
      }, null, 8, _hoisted_6)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("img", {
        class: "logo",
        src: _unref(LogoImageLg),
        loading: "lazy"
      }, null, 8, _hoisted_8),
      _createElementVNode("img", {
        class: "img-left",
        src: _unref(BannerLeftImageLg),
        loading: "lazy"
      }, null, 8, _hoisted_9),
      _createElementVNode("img", {
        class: "img-right",
        src: _unref(BannerRightImageLg),
        loading: "lazy"
      }, null, 8, _hoisted_10)
    ]),
    _hoisted_11
  ]))
}
}

})